<main class="access-page">
  <section class="access-card">
    <img src="assets/logo.png" width="56" height="56" alt="Kartorium">
    <h1>Organization sign-in</h1>
    <p>Use a sign-in method allowed by your organization to continue.</p>
    <p *ngIf="loading" role="status">Checking your sign-in options...</p>
    <p *ngIf="message" class="notice" role="status">{{ message }}</p>
    <p *ngIf="error" class="error" role="alert">{{ error }}</p>
    <button *ngIf="!loading && !authenticated" class="btn btn-primary" (click)="signIn()">Sign in</button>
    <ng-container *ngIf="!loading && authenticated">
      <button *ngIf="verificationCompleted" type="button" class="btn btn-primary mb-3" data-testid="return-organization-settings" [disabled]="saving" (click)="returnToSettings()">Return to organization settings</button>
      <ng-container *ngIf="options">
        <p *ngIf="options.requireCompanySso">This organization requires company SSO.</p>
        <div class="choices">
          <button *ngFor="let choice of options.connections" class="btn btn-outline-primary" (click)="continueWith(choice)">Continue with {{ label(choice) }}</button>
        </div>
        <p *ngIf="!options.connections.length">No allowed sign-in method is available. Contact your organization administrator.</p>
        <details class="recovery">
          <summary>Administrator recovery</summary>
          <p>Sign in with an account already connected to the administrator who saved the recovery code. Recovery restores the organization's allowed sign-in methods and records the change.</p>
          <div class="choices">
            <button *ngFor="let choice of options.recoveryConnections" class="btn btn-outline-secondary" (click)="continueWith(choice, true)">Verify with {{ label(choice) }}</button>
          </div>
          <form (ngSubmit)="recover()">
            <label for="recovery-code">Single-use recovery code</label>
            <input id="recovery-code" name="recoveryCode" type="password" class="form-control" [(ngModel)]="code" maxlength="256" autocomplete="off" [disabled]="saving">
            <button class="btn btn-primary" type="submit" [disabled]="saving || !code.trim()">{{ saving ? 'Recovering...' : 'Recover organization sign-in' }}</button>
          </form>
        </details>
      </ng-container>
      <button *ngIf="!options" class="btn btn-outline-primary" (click)="load()">Retry</button>
      <button class="btn btn-link" (click)="signIn()">Use another account</button>
    </ng-container>
  </section>
</main>
